// @flow
import { useLoadReports } from "queries/reports/useLoadReports";
import * as React from "react";
import { Helmet } from "react-helmet";
import PageWrapper from "ui/atoms/PageWrapper";
import Pagination from "ui/atoms/Pagination";
import PageTitle from "ui/molecules/PageTitle";

import { useFilters } from "../../../hooks/useQuery";
import ReportsFilter from "./ReportsFilter";
import ReportsTable from "./ReportsTable";

function ReportsPage(): React.Node {
  const {
    filters: { pageSize, ...filters },
  } = useFilters({ defaultValues: { page: 1, pageSize: 25 } });
  const { data: reports } = useLoadReports({
    ...filters,
    page_size: pageSize,
  });

  return (
    <PageWrapper className="pb-11">
      <Helmet>
        <title>Reports/Zentake</title>
      </Helmet>
      <PageTitle text="Reports" />

      <ReportsFilter />

      <ReportsTable />
      <Pagination.Border>
        <Pagination total={reports?.count || 0} />
      </Pagination.Border>
    </PageWrapper>
  );
}

export default ReportsPage;
